<template>
  <b-sidebar
    right
    shadow
    backdrop
    v-model="showSidebar"
    width="95%"
    @change="visibleChanged"
    no-header
    prop
  >
    <div>
      <div class="content-header bd-b pd-0">
        <nav
          ref="detailMainNav"
          class="navbar navbar-expand-lg bg-primary-light wd-100p"
          style="height: 59px"
        >
          Файл байршуулах
          <!-- <div class="dropdown">
            <a
              class="navbar-brand tx-bold tx-spacing--2 order-1"
              href="javascript:void(0)"
              data-toggle="dropdown"
            >
              <a
                class="
                  btn- btn-info btn-uppercase
                  pd-x-15 pd-t-10 pd-b-8
                  text-white
                  mg-r-10
                  rounded-sm
                "
              >
                <feather type="menu" class="mg-r-5"></feather>Цэс
              </a>
              цб
              <feather type="chevron-down" class="wd-15 ht-15"></feather>
            </a>
            <div class="dropdown-menu tx-13">
              <a class="dropdown-item" role="button">Засах</a>
            </div>
          </div> -->
          <button
            class="navbar-toggler order-2"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <feather type="menu" class="wd-20 ht-20"></feather>
          </button>

          <div
            class="collapse navbar-collapse order-2"
            id="navbarSupportedContent"
          >
            <button
              class="btn btn-sm pd-x-15 btn-uppercase mg-l-auto btn-danger"
              @click="visibleChanged(false)"
            >
              <feather type="x" class="feather wt-15 ht-15 pd-r-5"></feather
              >Хаах
            </button>
          </div>
        </nav>
      </div>
      <p v-if="!fetched"></p>
      <div v-else class="content-body pd-x-0 pd-y-0" style="overflow: hidden">
        <div class="container-fluid pd-x-0">
          <div class="d-flex" style="height: calc(100vh - 60px)">
            <div class="bd-r" style="width: 320px">
              <div style="width: 320px">
                <!-- <div class="pd-10 bg-white">
                  <button
                    class="btn btn-outline-light btn-xs btn-block"
                    
                  >
                    <i class="icon ion-md-add tx-14 mg-r-5 pd-t-5"></i> Хавтас үүсгэх
                  </button>
                </div> -->
                <div class="pd-10 bd-t">
                  <media-folders ref="mediaFolders"
                    @on-folder-selected="folderSelected"
                    propStyle="left: 0px;"
                  />
                </div>
              </div>
            </div>
            <div class="wd-100p">
              <div
                class="detail-content-header bd-b bg-white"
                style="height: 55px"
              >
                <nav class="navbar wd-100p pd-0">
                  <div class="pd-x-5 mg-b-10">
                    <button
                      v-show="chosenMode != 0"
                      class="
                        btn btn-xs btn-outline-primary btn-uppercase
                        mg-l-auto mg-t-10
                        task-finder-action-unlink
                      "
                      @click="chosenMode = 0"
                    >
                      <!-- v-show="chosenMode!=0" -->
                      <feather type="arrow-left"></feather> Буцах
                    </button>
                  </div>
                  <div
                    title=""
                    class="bd-l pd-l-10 text-truncate"
                    style="max-width: 50%"
                  >
                    <span v-show="chosenMode == 1">
                      Шинэ файл компьютерээс хуулах
                    </span>
                    <span v-show="chosenMode == 2"> Файл хавсаргах </span>
                    <span v-show="chosenMode > 3"> Документ файл үүсгэх </span>
                  </div>
                  <div class="mg-l-auto d-flex align-items-center"></div>
                </nav>
              </div>
              <vue-custom-scrollbar style="height: calc(100vh - 114px)">
                <template v-if="isFolderSelected">
                  <div v-if="chosenMode == 0" class="pd-10">
                    <div class="row row-xs">
                      <div class="col-6 col-sm-4 col-md-3 col-xl">
                        <div
                          class="card card-file"
                          @click="chooseMode(1)"
                          role="button"
                        >
                          <div class="card-file-thumb tx-danger">
                            <i class="fas fa-upload"></i>
                          </div>
                          <div class="card-body">
                            <h6><a class="link-02">Файл байршуулах</a></h6>
                            <span>Компьютерээс хуулах</span>
                          </div>
                          <!-- <div class="card-footer"><span class="d-none d-sm-inline">Last accessed: </span>2 hours ago</div> -->
                        </div>
                      </div>
                      <div
                        v-if="visibleSelectTab"
                        class="col-6 col-sm-4 col-md-3 col-xl"
                      >
                        <div
                          class="card card-file"
                          @click="chooseMode(visibleSelectTab ? 2 : 0)"
                          role="button"
                        >
                          <div class="card-file-thumb tx-info">
                            <i class="fas fa-link"></i>
                          </div>
                          <div class="card-body">
                            <h6>
                              <a class="link-02">файл хавсаргах</a>
                            </h6>
                            <span>Файл сангаас сонгох</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-6 col-sm-4 col-md-3 col-xl">
                        <div
                          class="card card-file"
                          role="button"
                          @click="chooseMode(3)"
                        >
                          <div class="card-file-thumb tx-info">
                            <i class="far fa-folder"></i>
                          </div>
                          <div class="card-body">
                            <h6>
                              <a class="link-02">Шинэ хавтас</a>
                            </h6>
                            <span>Шинээр хавтас үүсгэх</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr class="mg-y-40 bd-0" />
                    <label
                      class="
                        d-block
                        tx-medium
                        tx-10
                        tx-uppercase
                        tx-sans
                        tx-spacing-1
                        tx-color-03
                        mg-b-15
                      "
                      >Документ үүсгэх</label
                    >
                    <div class="row row-xs">
                      <div class="col-6 col-sm-4 col-md-3 col-xl">
                        <div
                          class="card card-file"
                          @click="chooseMode(4)"
                          role="button"
                        >
                          <div class="card-file-thumb tx-primary">
                            <i class="fas fa-file-word"></i>
                          </div>
                          <div class="card-body">
                            <h6><a class="link-02">Шинэ word</a></h6>
                            <span>Шинээр word файл үүсгэх</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-6 col-sm-4 col-md-3 col-xl">
                        <div
                          class="card card-file"
                          @click="chooseMode(5)"
                          role="button"
                        >
                          <div class="card-file-thumb tx-success">
                            <i class="fas fa-file-excel"></i>
                          </div>
                          <div class="card-body">
                            <h6><a class="link-02">Шинэ excel</a></h6>
                            <span>Шинээр excel файл үүсгэх</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-6 col-sm-4 col-md-3 col-xl">
                        <div
                          class="card card-file"
                          @click="chooseMode(6)"
                          role="button"
                        >
                          <div class="card-file-thumb tx-orange">
                            <i class="far fa-file-powerpoint"></i>
                          </div>
                          <div class="card-body">
                            <h6><a class="link-02">Шинэ powerpoint</a></h6>
                            <span>Шинээр powerpoint файл үүсгэх</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="chosenMode == 1">
                    <!-- -->
                    <div
                      style="
                        overflow: hidden auto;
                        height: calc(100vh - 114px);
                        display: table;
                        width: 100%;
                      "
                    >
                      <div
                        style="
                          text-align: center;
                          display: table-cell;
                          vertical-align: middle;
                          padding: 120px;
                        "
                      >
                        <Upload
                          :before-upload="handleBefore"
                          :on-error="handleError"
                          :on-success="handleSuccess"
                          :on-exceed="handleExceed"
                          :action="actionURL"
                          drag
                          :disabled="false"
                          :limit="100"
                          :multiple="false"
                          :show-file-list="false"
                          class="upld-wrpr"
                          :accept="dataAccept"
                        >
                          <div style="padding: 20px 0">
                            <i
                              class="fas fa-upload"
                              size="72"
                              style="font-size: 72px; color: #3399ff"
                            ></i>

                            <p class="pd-10">
                              Байршуулахын тулд энд дарж эсвэл файлуудыг чирж
                              болно
                            </p>
                          </div>
                        </Upload>
                      </div>
                    </div>
                  </div>
                  <div v-else-if="chosenMode > 3" class="pd-10">
                    <div data-label="Файл үүсгэх" class="df-example demo-forms">
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          v-model="themeName"
                          placeholder="Үүсгэх файлын нэрийг оруулна уу..."
                          aria-label="Үүсгэх файлын нэрийг оруулна уу..."
                          aria-describedby="button-addon2"
                        />
                        <div class="input-group-append">
                          <button
                            class="btn btn-success"
                            @click="createFile"
                            type="button"
                            id="button-addon2"
                          >
                            Үүсгэх
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="divider-text">
                      Доорх загваруудаас тохирох загвараа сонгоно уу
                    </div>
                    <div class="row row-xs">
                      <template
                        v-for="(temp, i) in templates.filter(
                          (x) =>
                            x.type ==
                            (chosenMode == 4 ? 0 : chosenMode == 5 ? 2 : 1)
                        )"
                      >
                        <div
                          class="col-6 col-sm-4 col-md-3 col-xl"
                          :key="`tmpl_${i}`"
                        >
                          <div
                            class="card card-file"
                            @click="selectedTheme = temp.id"
                            v-bind:style="{
                              backgroundColor:
                                selectedTheme == temp.id
                                  ? 'rgb(213, 232, 252)'
                                  : '',
                            }"
                          >
                            <div
                              :class="`
                                card-file-thumb
                                  
                                ${
                                  temp.type == 0
                                    ? 'tx-primary'
                                    : temp.type == 1
                                    ? 'tx-orange'
                                    : 'tx-success'
                                }`"
                            >
                              <i
                                v-if="temp.type == 0"
                                class="fas fa-file-word"
                              ></i>
                              <i
                                v-else-if="temp.type == 1"
                                class="fas fa-file-powerpoint"
                              ></i>
                              <i
                                v-else-if="temp.type == 2"
                                class="fas fa-file-excel"
                              ></i>
                            </div>
                            <div class="card-body">
                              <h6>
                                <a class="link-02">{{ temp.name }}</a>
                              </h6>
                              <span>
                                {{
                                  temp.type == 0
                                    ? "Word файлын загвар"
                                    : temp.type == 1
                                    ? "Powerpoint файлын загвар"
                                    : "Excel файлын загвар"
                                }}</span
                              >
                            </div>
                          </div>
                        </div>
                        <div
                          v-if="(i + 1) % 5 == 0"
                          class="d-none d-xl-block wd-100p ht-10"
                          :key="`tmpl_${i}`"
                        ></div>
                      </template>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div
                    style="
                      overflow: hidden auto;
                      height: calc(100vh - 114px);
                      display: table;
                      width: 100%;
                      background-color: lavender;
                    "
                  >
                    <div
                      style="
                        text-align: center;
                        display: table-cell;
                        vertical-align: middle;
                        cursor: pointer;
                        font-size: 2rem;
                      "
                      class="text-muted"
                      id="choosefolder-outer"
                    >
                      <i
                        class="
                          fa fa-arrow-left
                          move-left fa-beat
                        "
                        style="font-size: 6rem"
                      ></i>
                      <div>Файл байршуулах хавтасаа сонгоно уу</div>
                    </div>
                  </div>
                </template>
              </vue-custom-scrollbar>

              <!----><!---->
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-sidebar>
</template>

<script>
import { request } from "@/api/all";
import vueCustomScrollbar from "vue-custom-scrollbar";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import { Upload } from "element-ui";
import { mapActions } from "vuex";
import { getToken } from "@/libs/util";

export default {
  name: "fileUploader",
  components: {
    Upload,
    vueCustomScrollbar,
    mediaFolders: () => ({
      component: import("@/views/modules/media/components/folder.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  props: {
    config: {
      type: Object,
      default: () => {},
    },
    propAccept: {
      type: String,
      default: () => "",
    },
    // folderId: {
    //   type: Number,
    //   default: () => null
    // },
    boxId: {
      type: Number,
      default: () => 0,
    },
    objectTypeId: {
      type: Number,
      default: () => 0,
    },
    mode: {
      type: Number,
      default: () => 0,
    },
    objectId: {
      type: String,
      default: () => "0",
    },
    visibleCreateTab: {
      type: Boolean,
      default: () => true,
    },
    propFolderId: {
      type: Number,
      default: () => null,
    },
    propBoxId: {
      type: Number,
      default: () => 0,
    },
    propObjectTypeId: {
      type: Number,
      default: () => 0,
    },
    propMode: {
      type: Number,
      default: () => 0,
    },
    propObjectId: {
      type: String,
      default: () => "",
    },
    taskId: {
      type: Number,
      default: () => 0,
    },
    selectGroupAdminDefaultFolder: {
      type: Boolean,
      default: () => false,
    },
    propTaskSearchModel: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isFolderSelected: false,
      fetched: true,
      showSidebar: false,
      chosenMode: 0,
      visibleSelectTab: false,
      dataAccept: "",
      actionURL: "",
      params: {
        folderId: 0,
      },
      baseURL: "https://mobcore.gosmart.mn/",
      templates: [],
      selectedTheme: 0,
      themeName: "",
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions(["handleLoading"]),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    init() {
      if (
        this.$store.state.app.activeGroup.baseUrl != undefined &&
        this.$store.state.app.activeGroup.baseUrl != ""
      ) {
        this.baseURL = this.$store.state.app.activeGroup.baseUrl;
      }

      this.params.objectTypeId = this.propObjectTypeId;
      this.params.objectId = this.propObjectId;
      this.params.boxId = this.propBoxId;
      this.params.folderId = this.propFolderId;
      this.params.mode = this.propMode;

      if (
        this.params.objectTypeId == 0 ||
        this.params.objectTypeId == null ||
        this.params.objectTypeId == undefined
      ) {
        this.params.objectTypeId = 6;
      }
      if (this.visibleCreateTab) {
        request({
          api: { method: "GET", url: "Media/getTemplateList" },
          store: this.$store,
        }).then((res) => {
          this.templates = res.data.templates;
        });
      }

      this.showSidebar = true;
    },
    createFile() {
      if (this.themeName == "") {
        Notice.warning({
          title: "Сануулга",
          desc: "Үүсгэх файлын нэрээ оруулна уу",
          duration: 10,
        });
      } else if (this.selectedTheme == 0) {
        Notice.warning({
          title: "Сануулга",
          desc: "Файл үүсгэх загвараа сонгоно уу",
          duration: 10,
        });
      } else {
        request({
          api: { method: "POST", url: "Media/CreateDoc" },
          data: {
            FolderId: this.params.folderId,
            BoxId: this.params.boxId,
            ObjectId: this.params.objectId,
            ObjectTypeId: this.params.objectTypeId,
            Title: this.themeName,
            TemplateId: this.selectedTheme,
            TaskId: this.taskId,
          },
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            this.$emit("input", { response: res });
            this.$emit("on-success", { response: res });
            if (this.dontPushOnCreate) {
            } else {
              let _h = screen.availHeight - 60;
              let _w = screen.availWidth - 20;
              window.open(
                "#/Media/EditorBlank/" + res.data.uploadedAttachmentId,
                "_blank",
                "toolbar=no,scrollbars=yes,resizable=yes,top=0,left=0,width=" +
                  _w +
                  ",height=" +
                  _h
              );
            }
          }
        });
      }
    },
    chooseMode(e) {      
      if(e==3){
        //console.log(this.$refs.mediaFolders)
        this.$refs.mediaFolders.showModal();
      }
      else{
        this.chosenMode = e;
      }
      if (e == 4 || e == 5 || e == 6) {
        this.themeName = "";
        this.selectedTheme = 0;
      }
    },
    folderSelected(e) {
      //console.log(e);
      this.isFolderSelected = e.id > 0;

      this.params.folderId = e.id;

      this.actionURL =
        this.baseURL +
        "core/uploader?boxId=" +
        this.boxId +
        "&folderId=" +
        this.params.folderId +
        "&objectTypeId=" +
        this.objectTypeId +
        "&objectId=" +
        this.objectId +
        "&mode=" +
        this.mode +
        "&token=" +
        getToken();
      //console.log(this.actionURL)
    },
    handleExceed() {
      //this.$Message.warning({content: this.fileExceedMsg, duration: 15});
      this.toggleBodyClass("removeClass", "dynamic-locker");
      this.uploadStart = false;
      this.$bvToast.toast("1 удаа 100-с илүү файл хуулах боломжгүй", {
        title: "Сануулга",
        autoHideDelay: 10000,
        appendToast: true,
        variant: "success",
        toaster: "b-toaster-bottom-left",
      });
    },
    handleBefore(file) {
      if (this.folderId == 0) {
        //this.$Message.warning("Файл байршуулах хавтас сонгоно уу");
        this.$bvToast.toast("Файл байршуулах хавтас сонгоно уу", {
          title: "Сануулга",
          autoHideDelay: 10000,
          appendToast: true,
          variant: "warning",
          toaster: "b-toaster-bottom-left",
        });
        return false;
      } else {
        if (file.size / 1024 > this.fileExceedSize) {
          this.$bvToast.toast(this.fileExceedMsg, {
            title: "Сануулга",
            autoHideDelay: 10000,
            appendToast: true,
            variant: "warning",
            toaster: "b-toaster-bottom-left",
          });
          return false;
        }
        this.handleLoading({ isLoading: true });
        this.toggleBodyClass("addClass", "dynamic-locker");
        this.uploadStart = true;
      }
    },
    handleError(e) {
      //console.log(e);
      this.toggleBodyClass("removeClass", "dynamic-locker");
      this.$emit("on-error", e);
    },
    handleSuccess(e) {
      //console.log(e)
      this.handleLoading({ isLoading: false });
      this.toggleBodyClass("removeClass", "dynamic-locker");
      this.uploadStart = false;
      if (e.code == 200) {
        //console.log(e);
        //this.$emit("inpit", { response: e });
        //this.$emit("on-success", { response: e });
        this.$emit("inpit", e.data);
        this.$emit("on-success", e.data);

        this.$bvToast.toast("Файлыг серверт амжилттай хууллаа", {
          title: "Амжилттай",
          autoHideDelay: 2000,
          appendToast: true,
          variant: "success",
          toaster: "b-toaster-bottom-left",
        });
        // this.$Notice.success({
        //   title: "Амжилттай",
        //   desc: "Файлыг серверт амжилттай хууллаа."
        // });
      } else {
        this.$bvToast.toast(e.msg, {
          title: "Сануулга",
          autoHideDelay: 5000,
          appendToast: true,
          variant: "error",
          toaster: "b-toaster-bottom-left",
        });
        // this.$Notice.warning({
        //   title: "Сануулга",
        //   desc: e.msg
        // });
      }
    },

    visibleChanged(e) {
      if (!e) {
        Object.assign(this.$data, this.$options.data());
        this.$emit("on-uploader-close");
      }
    },
  },
};
</script>
<style >
.go-file-create-area > div > div {
  background: rgba(255, 255, 255, 1);
  margin: 5px;
  border-radius: 5px;
  padding: 5vh;
  color: #99a6ad;
  font-weight: 700;
  text-transform: uppercase;
  cursor: pointer;
}
</style>
